import React from "react";
import {styled} from "@mui/material/styles";
import {useTranslation} from "react-i18next";
import {Divider} from '@mui/material';
import GoldenSwitch from "../goldenSwitch/GoldenSwitch";

const PREFIX = "UserRights";

const classes = {
  paper: `${PREFIX}-paper`,
  checkboxesRow: `${PREFIX}-checkboxesRow`,
  maxWidthCheckbox: `${PREFIX}-maxWidthCheckbox`,
  marginBottom: `${PREFIX}-marginBottom`,
  superAdminCheckbox: `${PREFIX}-superAdminCheckbox`,
};

const Root = styled("div")(({theme}) => ({
  [`&.${classes.paper}`]: {
    padding: "0.5rem",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    margin: "0 auto",
    [theme.breakpoints.up("sm")]: {
      minWidth: "400px",
    },
  },

  [`& .${classes.checkboxesRow}`]: {
    display: "flex",
    justifyContent: "space-between",
    height: "65px",
    width: "100%",
  },

  [`& .${classes.maxWidthCheckbox}`]: {
    width: "50%",
  },

  [`& .${classes.marginBottom}`]: {
    marginBottom: "1rem",
  },

  [`& .${classes.superAdminCheckbox}`]: {
    display: "flex",
    justifyContent: "center",
    padding: "1rem",
  },
}));

const UserRights = (props) => {
  const {t} = useTranslation();

  const handleRight = (key, enabled) => {
    const tmp = [...props.rights];
    if (enabled) {
      tmp.push(key);
    } else {
      tmp.splice(
        tmp.findIndex((item) => item === key),
        1
      );
    }
    props.setRulesModal({...props.rulesModal, rights: tmp});
  };

  return (
    <Root>
      <div className={classes.paper}>
        <div className={classes.superAdminCheckbox}>
          <GoldenSwitch
            checked={props.rulesModal.isSuperAdmin}
            onChange={(e) =>
              props.setRulesModal({
                ...props.rulesModal,
                isSuperAdmin: e.target.checked,
              })
            }
            label={t("users.roles.superAdmin")}
          />
        </div>
        <Divider light className={classes.marginBottom}/>
        <div className={classes.checkboxesRow}>
          <GoldenSwitch
            className={classes.maxWidthCheckbox}
            checked={props.rights.includes("faz")}
            onChange={(e) => handleRight("faz", e.target.checked)}
            label={t("users.roles.adminHome")}
          />
          <GoldenSwitch
            className={classes.maxWidthCheckbox}
            checked={props.rights.includes("rights")}
            onChange={(e) => handleRight("rights", e.target.checked)}
            label={t("users.roles.adminRights")}
          />
        </div>
        <div className={classes.checkboxesRow}>
          <GoldenSwitch
            className={classes.maxWidthCheckbox}
            checked={props.rights.includes("exp")}
            onChange={(e) => handleRight("exp", e.target.checked)}
            label={t("users.roles.adminExparience")}
          />
          <GoldenSwitch
            className={classes.maxWidthCheckbox}
            checked={props.rights.includes("designs")}
            onChange={(e) => handleRight("designs", e.target.checked)}
            label={t("users.roles.myDesigns")}
          />
        </div>
        <div className={classes.checkboxesRow}>
          <GoldenSwitch
            className={classes.maxWidthCheckbox}
            checked={props.rights.includes("cat")}
            onChange={(e) => handleRight("cat", e.target.checked)}
            label={t("users.roles.adminCategories")}
          />
          <GoldenSwitch
            className={classes.maxWidthCheckbox}
            checked={props.rights.includes("camp")}
            onChange={(e) => handleRight("camp", e.target.checked)}
            label={t("users.roles.adminCampaigns")}
          />
        </div>
        <div className={classes.checkboxesRow}>
          <GoldenSwitch
            className={classes.maxWidthCheckbox}
            checked={props.rights.includes("users")}
            onChange={(e) => handleRight("users", e.target.checked)}
            label={t("users.roles.adminUsers")}
          />
          <GoldenSwitch
            className={classes.maxWidthCheckbox}
            checked={props.rights.includes("ent")}
            onChange={(e) => handleRight("ent", e.target.checked)}
            label={t("users.roles.adminEntities")}
          />
        </div>
        <div className={classes.checkboxesRow}>
          <GoldenSwitch
            className={classes.maxWidthCheckbox}
            checked={props.rights.includes("journeys")}
            onChange={(e) => handleRight("journeys", e.target.checked)}
            label={t("users.roles.adminJourneys")}
          />
          <GoldenSwitch
            className={classes.maxWidthCheckbox}
            checked={props.rights.includes("grafana")}
            onChange={(e) => handleRight("grafana", e.target.checked)}
            label={t("users.roles.grafana")}
          />
        </div>
        <div className={classes.checkboxesRow}>
          <GoldenSwitch
            className={classes.maxWidthCheckbox}
            checked={props.rights.includes("Crm")}
            onChange={(e) => handleRight("Crm", e.target.checked)}
            label={t("users.roles.Crm")}
          />
          <GoldenSwitch
            className={classes.maxWidthCheckbox}
            checked={props.rights.includes("Hdr")}
            onChange={(e) => handleRight("Hdr", e.target.checked)}
            label={t("users.roles.Hdr")}
          />
        </div>
        <div className={classes.checkboxesRow}>
          <GoldenSwitch
            className={classes.maxWidthCheckbox}
            checked={props.rights.includes("payments")}
            onChange={(e) => handleRight("payments", e.target.checked)}
            label={t("users.roles.payments")}
          />
          <GoldenSwitch
            className={classes.maxWidthCheckbox}
            checked={props.rights.includes("QRCodes")}
            onChange={(e) => handleRight("QRCodes", e.target.checked)}
            label={t("users.roles.qrCode")}
          />
        </div>
        <div className={classes.checkboxesRow}>
          <GoldenSwitch
            className={classes.maxWidthCheckbox}
            checked={props.rights.includes('models')}
            onChange={e => handleRight('models', e.target.checked)}
            label={t('users.roles.models')}
          />
          <GoldenSwitch
            className={classes.maxWidthCheckbox}
            checked={props.rights.includes("classes")}
            onChange={(e) => handleRight("classes", e.target.checked)}
            label={t("users.roles.classes")}
          />
        </div>
        <div className={classes.checkboxesRow}>
          <GoldenSwitch
            className={classes.maxWidthCheckbox}
            checked={props.rights.includes("bizDev")}
            onChange={(e) => handleRight("bizDev", e.target.checked)}
            label={"Biz Dev"}
          />
        </div>
      </div>
    </Root>
  );
};

export default UserRights;
